<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3uKpPp/media/FC-9781398417618.jpg?1685203883051" alt="This image is the cover for the book Immortalaeism II"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Immortalaeism II
      </h1>
      <p class="bookDescription body article font2">
        <p>Immortalaeism II provides a book of application for power itself, and it also provides a book of application to the notions of eternal life and immortality. By crowning the series this far with a second book of Immortalae, which is the treatise of heroism, Vaul Impera provides a personal reality, where all of his philosophy and spiritualism may be applied; the idea of immortality itself. Combining the skill of power itself, given by a series of visions with the knowledge of immortality, Vaul pours this series together into the mould of an immortal man, as constant in the Universe as time, or justice. He foretells of the immortal man, a creation of the spiritual-philosophy he has written, Immortalaeism.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vaul Impera
      </h2>
      
      <p class="authorDescription body article">Vaul Impera is the originator and creator of Immortalaeism, and the first to adopt it as a philosophical/spiritual paradigm. He has been offered international law to fight against sex trades by Parliament of Canada. He has been offered leadership positions in the army, and he has been offered high positions in the Church.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c9fb9130